import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "horizontal-scroll-slider__buttons",
  ref: "buttons"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "horizontal-scroll-slider__button-title" }
const _hoisted_4 = {
  class: "horizontal-scroll-slider__intro",
  ref: "intro"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "horizontal-scroll-slider__slides",
  ref: "slidesContainer"
}
const _hoisted_8 = {
  viewBox: "0 0 1747 597",
  preserveAspectRatio: "xMinYMid",
  ref: "truckPathSVG",
  class: "horizontal-scroll-slider__path",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = { transform: "translate(0.000000, 80.000000)" }
const _hoisted_10 = {
  d: "M5.99910136,224 L5.99910136,26.34 C5.99910136,26.34 5.81,0.5 31.84,0.5 L328.16,0.5 C328.16,0.5 352.88,0.5 354,26.34 L354,66.34 C354,66.34 357.34,89.09 384.91,87.47 L415.16,87.47 C415.16,87.47 441,88.63 441,111.74 L441,409.66 C441,409.66 441.19,435.502913 466.5,435.502913 L762.92,435.502913 C762.92,435.502913 788.76,436.07 788.76,409.66 L788.76,372.26 C788.76,372.26 791.47,348.76 813.66,348.76 L850.16,348.76 C850.16,348.76 876,349.36 876,322.92 L876,26.34 C876,26.34 875.42,0.5 901.84,0.5 L1198.16,0.5 C1198.16,0.5 1224,1.18 1224,29.5 L1224,62.6 C1224,62.6 1224.86,88.98 1255.93,87.5 L1285.16,87.5 C1285.16,87.5 1308.88,87.18 1311,112.5 L1311,409.66 C1311,409.66 1311.72,435.502913 1336.84,435.502913 L1633.46,435.502913 C1633.46,435.502913 1659.28,434.5 1659,409.66 L1659,378.5 C1659,378.5 1658.1,353.01 1680.07,348.76 L1723.16,348.11 C1723.16,348.11 1746,346.89 1746,322.11 L1746,224",
  id: "truck-path",
  ref: "path",
  class: "horizontal-scroll-slider__truck-path",
  stroke: "#f0f",
  fill: "none"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0.000000, 212.000000)",
  fill: "#0AAA64",
  "fill-rule": "nonzero"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    class: "horizontal-scroll-slider__truck",
    x: "0",
    y: "0",
    width: "12",
    height: "12",
    rx: "3"
  })
], -1)
const _hoisted_12 = { class: "slider__controls-wrapper" }
const _hoisted_13 = { class: "slider__controls horizontal-scroll-slider__controls" }
const _hoisted_14 = { class: "slider__indicators" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["horizontal-scroll-slider", { 'horizontal-scroll-slider--edit-mode': _ctx.editMode }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, s) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `slideBtn#${s}`,
          onClick: ($event: any) => (_ctx.gotoSlide(s + 1)),
          class: _normalizeClass(["horizontal-scroll-slider__button", [{ 'horizontal-scroll-slider__button-active': s + 1 === _ctx.index }, `horizontal-scroll-slider__button-${slide.icon}`]])
        }, [
          (slide.icon)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 0,
                name: slide.icon,
                class: "horizontal-scroll-slider__button-icon"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(slide.title), 1)
        ], 10, _hoisted_2))
      }), 128))
    ], 512),
    _createElementVNode("div", {
      class: "horizontal-scroll-slider__wrapper horizontal-scroll-slider__main-wrapper",
      style: _normalizeStyle({ transform: `translateX(-${_ctx.progress}px)` }),
      ref: "slider"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "horizontal-scroll-slider__intro-title",
          innerHTML: _ctx.$truncate(_ctx.title)
        }, null, 8, _hoisted_5),
        _createElementVNode("div", {
          class: "text horizontal-scroll-slider__intro-text",
          innerHTML: _ctx.$truncate(_ctx.text, 310)
        }, null, 8, _hoisted_6)
      ], 512),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock("svg", _hoisted_8, [
          _createElementVNode("g", _hoisted_9, [
            _createElementVNode("path", _hoisted_10, null, 512),
            _hoisted_11
          ])
        ], 512)),
        _createVNode(_component_icon, {
          name: "icn-arrow",
          class: "horizontal-scroll-slider__arrow"
        }),
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 4),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_icon, {
          name: "icn-bracket",
          class: "slider__controls-bracket"
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["button button--borderless button--reverse", { 'button--disabled': _ctx.index === 0 }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
        }, null, 2),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["slider__indicator", { 'slider__indicator--active': _ctx.index === 0 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoSlide(0)))
          }, null, 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: slide._uid,
              class: _normalizeClass(["slider__indicator", { 'slider__indicator--active': _ctx.index === i + 1 }]),
              onClick: ($event: any) => (_ctx.gotoSlide(i + 1))
            }, null, 10, _hoisted_15))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["button button--borderless", { 'button--disabled': _ctx.index >= _ctx.slides.length }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
        }, null, 2),
        _createVNode(_component_icon, {
          name: "icn-bracket",
          class: "slider__controls-bracket slider__controls-bracket-right"
        })
      ])
    ])
  ], 2))
}